import usePageStore from '~/stores/page';
import type { IPagesConfig } from '~~/configs/pages.config';
import pagesConfig from '../../configs/pages.config';

export default async function useSingleton(collectionName: string) {
  const { objectKeysToCamelCase } = formatUtils();
  const cms = useCms();
  const { setCurrentPage } = usePageStore();

  // Configuratie ophalen
  const pageTypeDefinition = pagesConfig[collectionName] || (pagesConfig.home as IPagesConfig);
  const { fields } = pageTypeDefinition;

  // unieke key
  const key = `singleton_${collectionName}`;

  // Data ophalen via useAsyncData
  const { data, error } = await useAsyncData(
    key,
    () => cms.readSingleton(collectionName, { fields }),
    {
      transform: (rawData) => (rawData ? objectKeysToCamelCase(rawData) : null),

      getCachedData: (key) => {
        const nuxtApp = useNuxtApp();

        return nuxtApp.payload.data[key] || nuxtApp.static.data[key];
      },
    },
  );

  if (error.value) {
    console.error(`Error loading singleton ${collectionName}:`, error.value);
    throw error.value;
  }

  if (data.value) {
    setCurrentPage(data.value);
  }

  return data.value;
}
